import "react-typist/dist/Typist.css";

import { Grow, Typography } from "@material-ui/core";
import {
  StyleRulesCallback,
  WithStyles,
  withStyles
} from "@material-ui/core/styles";
import * as React from "react";
// @ts-ignore
import Typist from "react-typist";

import DistortedText from "./DistortedText/DistortedText";
import JobsLink from "./JobsLink";
import JobsSectionBody from "./JobsSectionBody";
import JobsSectionTitle from "./JobsSectionTitle";
import JobsTechStack from "./JobsTechStack";
import MatrixBackground from "./MatrixBackground/MatrixBackground";

const styles: StyleRulesCallback = ({ palette, spacing, breakpoints }) => ({
  container: {
    minHeight: "100vh",
    backgroundColor: palette.common.black,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
    paddingTop: 140,
    boxSizing: "border-box",
    color: palette.common.white
  },

  innerContainer: {
    width: 600,
    zIndex: 2,
    [breakpoints.down(800)]: {
      width: "90vw",
      alignSelf: "stretch",
      minWidth: 300,
      paddingLeft: spacing.unit * 2,
      boxSizing: "border-box"
    }
  },
  footer: {
    color: palette.primary.dark,
    fontSize: 11,
    alignSelf: "center",
    marginTop: 200,
    textAlign: "center",
    opacity: 0.5,
    marginBottom: spacing.unit * 2
  }
});

interface IState {
  finishedTyping: boolean;
}

@(withStyles(styles) as any)
export default class JobsPage extends React.Component<
  Partial<WithStyles<any>>,
  IState
> {
  public state: IState = {
    finishedTyping: false
  };

  public render() {
    const { classes } = this.props;
    const { finishedTyping } = this.state;
    return (
      <div className={classes!.container}>
        <MatrixBackground animate={finishedTyping} />

        <div className={classes!.innerContainer}>
          <DistortedText text="WE ARE HIRING" />

          {this.renderIntro()}
          {this.renderAboutUs()}
          {this.renderAboutYou()}
          {this.renderWhyUs()}
          {this.renderWhere()}
          {this.renderTechStack()}
          {this.renderTeam()}
          {this.renderApply()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }

  private onFinishedTyping = () => this.setState({ finishedTyping: true });

  private renderIntro() {
    const { finishedTyping } = this.state;


 
    if (!finishedTyping) {
      return (
        <>
          <JobsSectionBody>
            <Typist
              onTypingDone={this.onFinishedTyping}
              avgTypingDelay={50}
              cursor={{ hideWhenDone: true }}
            >
              <Typist.Delay ms={3000} key="1" />
              <b>Salaryo</b> is looking for{" "}
              {this.renderAndDelete("code monkeys")}
              {this.renderAndDelete("hackers")}
              {this.renderAndDelete("developers")}
              <b>full stack software engineers</b>{" "}
              <Typist.Delay ms={300} key="2" /> to join our founding team.
              <br />
              <Typist.Delay ms={2000} key="3" />
              <br />
              We look for <b>self-starters; </b>
              <Typist.Delay ms={1000} key="4" />
              those with a <b>founder mentality</b>. <br />{" "}
              <Typist.Delay ms={1000} key="5" />
              We ship every day. <Typist.Delay ms={500} key="6" />
              We embrace bold ideas and <b>encourage experimentation</b>.
            </Typist>
          </JobsSectionBody>
        </>
      );
    } else {
      return (
        <>
          <JobsSectionBody>
            <Typist.Delay ms={3000} key="1" />
            <b>Salaryo</b> is looking for <b>full stack software engineers</b>{" "}
            to join our founding team.
            <br />
            <br />
            We look for <b>self-starters; </b>
            those with a <b>founder mentality</b>. <br /> We ship every day. We
            embrace bold ideas and <b>encourage experimentation</b>.
          </JobsSectionBody>
        </>
      );
    }
  }

  private renderAndDelete(text: string, delay: number = 600) {
    return (
      <span>
        <b>{text}</b>
        <Typist.Backspace count={text.length} delay={delay} key={text} />
      </span>
    );
  }

  private renderAboutUs() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        timeout={3000}
        mountOnEnter={true}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>about salaryo</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            Salaryo is creating a <b>bank</b> for <b>the future of work</b>.
            <br />
            We're a curious, motivated group of founders, driven by the goal of
            creating financial products that answer the needs of modern workers.
            Check out{" "}
            <JobsLink href="https://salaryo.com">
              <b>salaryo.com</b>
            </JobsLink>{" "}
            for more details.
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderAboutYou() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        timeout={4000}
        mountOnEnter={true}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>who are you?</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            You should be someone that <b>likes to ship</b>, comfortable working
            across the <b>entire stack</b> (React, Node.js, Google Cloud). You
            should have a <b>product mindset</b>. You should be proud of your
            code but knowledgeable enough to know how to manage implementation
            tradeoffs.
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderWhyUs() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        timeout={5000}
        mountOnEnter={true}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>why us?</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            ○ <b>We're just starting</b> - You'll have tons of impact on the
            company, technology, and the product.
            <br />○ <b>The working life</b> - everyone works hard but also takes
            the time to enjoy life outside of the office. Balance is important
            to us.
            <br />○ <b>Creative freedom</b> - you'll have tons of freedom to
            learn and use cutting edge technology.
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderWhere() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        timeout={6000}
        mountOnEnter={true}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>where?</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            Tel Aviv, Echad Ha'am 54,{" "}
            <JobsLink href="https://thinkrise.com/tel-aviv">
              <b>rise</b>
            </JobsLink>{" "}
            coworking space.
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderTechStack() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        mountOnEnter={true}
        timeout={7000}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>our tech stack</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            We're proud to say that we're <b>completely serverless</b> (and aim
            to stay that way). We believe in{" "}
            <b>productivity over performance</b>. Our entire stack is written in{" "}
            <b>Typescript</b> using <b>React</b> and <b>Node.js</b>. Having that
            said, we're open-minded and believe in choosing the right tool for
            each job.
            <br />
            <br />
          </JobsSectionBody>
          <JobsTechStack />
        </div>
      </Grow>
    );
  }

  private renderTeam() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        mountOnEnter={true}
        timeout={8000}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>the team</JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            ○{" "}
            <JobsLink href="https://www.linkedin.com/in/itay-dressler-a4548b33/">
              <b>Itay Dressler (CTO)</b>
            </JobsLink>
            <br />
            <br /> ○{" "}
            <JobsLink href="https://www.linkedin.com/in/levyair/">
              <b>Yair Levy (CEO)</b>
            </JobsLink>
            <br /> <br />○{" "}
            <JobsLink href="https://www.linkedin.com/in/omri-avisar-b497a016/">
              <b>Omri Avisar (CPO)</b>
            </JobsLink>
            <br />
            <br /> ○{" "}
            <JobsLink href="https://www.linkedin.com/in/asaf-joseph-zagury-adv-a6743763/">
              <b>Asaf Zagury (COO)</b>
            </JobsLink>
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderApply() {
    const { finishedTyping } = this.state;
    return (
      <Grow
        in={finishedTyping}
        mountOnEnter={true}
        timeout={9000}
        style={{ transformOrigin: "50% 0 0" }}
      >
        <div>
          <JobsSectionTitle>JOIN US </JobsSectionTitle>
          <JobsSectionBody isGreen={true}>
            To apply send your CV or a link to your LinkedIn account{" "}
            <JobsLink href="mailto:jobs@salaryo.com" openInSameTab={true}>
              <b>HERE</b>
            </JobsLink>
          </JobsSectionBody>
        </div>
      </Grow>
    );
  }

  private renderFooter() {
    const { classes } = this.props;
    const { finishedTyping } = this.state;
    if (finishedTyping) {
      return (
        <Typography className={classes!.footer}>
          inspired by Torii & product hunt ❤️
        </Typography>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/JobsPage.tsx